import React from "react";
import { FilterChipsContainer, FilterChip } from './styles';

export interface FilterChipItem {
  id: string;
  label: string;
  selected?: boolean;
}

export interface FilterChipsProps {
  chips: FilterChipItem[];
  onChipClick?: (chipId: string) => void;
  className?: string;
}

const FilterChips: React.FC<FilterChipsProps> = ({
  chips,
  onChipClick,
  className
}) => {
  return (
    <FilterChipsContainer className={className}>
      {chips?.map((chip) => (
        <FilterChip
          key={chip.id}
          selected={chip.selected}
          onClick={() => onChipClick?.(chip.id)}
        >
          {chip.label}
        </FilterChip>
      ))}
    </FilterChipsContainer>
  );
};

export default FilterChips;
